import { render, staticRenderFns } from "./gj-account-select.vue?vue&type=template&id=f3845856&scoped=true&"
import script from "./gj-account-select.vue?vue&type=script&lang=js&"
export * from "./gj-account-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3845856",
  null
  
)

export default component.exports